/**
 * "How it works": pinned horizontal scroll on desktop (900px+), with a progress line.
 * Below 900px (and under reduced motion) the steps simply stack; gsap.matchMedia reverts
 * the pin cleanly when the viewport crosses the breakpoint.
 *
 * Must be created BEFORE the reveal triggers so their positions include the pin spacer.
 */
import { gsap } from 'gsap';

export function initHorizontal() {
  const section = document.querySelector('[data-how]');
  if (!section) return;
  const track = section.querySelector('[data-how-track]');
  const bar = section.querySelector('[data-how-progress]');
  const mm = gsap.matchMedia();

  mm.add('(min-width: 900px)', () => {
    section.classList.add('is-horizontal');
    const distance = () => Math.max(0, track.scrollWidth - window.innerWidth);
    const tween = gsap.to(track, {
      x: () => -distance(),
      ease: 'none',
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: () => `+=${distance()}`,
        pin: true,
        scrub: 0.8,
        refreshPriority: 1,
        invalidateOnRefresh: true,
        onUpdate: (self) => gsap.set(bar, { scaleX: self.progress }),
      },
    });
    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
      gsap.set([track, bar], { clearProps: 'all' });
      section.classList.remove('is-horizontal');
    };
  });

  // Stacked layout: the progress line simply fills as the list scrolls past.
  mm.add('(max-width: 899px)', () => {
    const t = gsap.fromTo(bar, { scaleX: 0 }, { scaleX: 1, ease: 'none', scrollTrigger: { trigger: track, start: 'top 75%', end: 'bottom 60%', scrub: true } });
    return () => t.scrollTrigger?.kill();
  });
}
